<template>
  <div class="app-container column-detail">
  <basic-container>
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="first">
        <!-- <el-row class="one-line">
          <el-col :span="2">ID：</el-col>
          <el-col :span="16">{{id}}</el-col>
        </el-row> -->
        <el-row class="one-line">
          <el-col :span="2">封面图：</el-col>
          <el-col :span="16">
            <img class="cover-image" :src="coverImg" />
          </el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">名称：</el-col>
          <el-col :span="16">{{circleName}}</el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">描述：</el-col>
          <el-col :span="16">{{description}}</el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">作者：</el-col>
          <el-col :span="16">{{createdByName}}</el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">标签：</el-col>
          <el-col :span="16" v-show="!isEdit">
            <span v-if="originTags.length === 0">--</span>
            <span v-for="(item, index) in originTags" :key="item.tagId">{{(index === 0 ? '' : '，') + item.tagName}}</span>
            <el-button type="primary" size="mini" @click="handleEdit" class="edit-button">编辑</el-button>
          </el-col>
          <el-col :span="16" v-show="isEdit">
            <el-select v-model="tags" value-key="tagId" multiple filterable remote :remote-method="remoteSearchTag">
                <el-option
                  v-for="item in tagListOptions"
                  :key="item.tagId"
                  :label="item.tagName"
                  :value="item"
                  >
                </el-option>
              </el-select>
            <el-button type="primary" size="mini" @click="handleSaveEdit">保存</el-button>
            <el-button size="mini" @click="handleCancelEdit">取消</el-button>
          </el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">文章数：</el-col>
          <el-col :span="16">
            <el-button type="text" @click="toPostList">{{postCount}}</el-button>
          </el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">状态：</el-col>
          <el-col :span="16">{{activeText}}</el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">创建时间：</el-col>
          <el-col :span="16">{{createdTime}}</el-col>
        </el-row>
        <el-row class="one-line">
          <el-col :span="2">更新时间：</el-col>
          <el-col :span="16">{{updatedTime}}</el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="订阅者">
        <basic-container class="circle-members">
          <avue-crud
            ref="memberCrud"
            :page="memberPage"
            :data="memberTableData"
            :table-loading="memberTableLoading"
            :option="columnMemberOption"
            @current-change="memberCurrentChange"
            @refresh-change="getMemberList"
            @size-change="memberSizeChange">
          </avue-crud>
        </basic-container>
      </el-tab-pane>
    </el-tabs>
  </basic-container>
  </div>
</template>
<script>
import {
  getObj,
  fetchMemberList,
  fetchTagList,
  updateCircleTags
} from "@/api/post/circle"
import {
  columnMemberOption
} from "@/const/crud/post/column"
import { getTagListByTag } from '@/api/dict/tag'

const initDetail = vm => {
  getObj(vm.id).then(response => {
    formatDetail(vm, response.data.data)
  }).catch(error => {
    console.error(error)
    vm.$message({
      message: error,
      type: 'error'
    })
  })
  vm.getTagList()
  vm.getMemberList()
}

const formatDetail = (vm, data) => {
  vm.coverImg = data.coverImg
  vm.circleName = data.circleName
  vm.createdByName = data.createdByName
  vm.description = data.description
  vm.isActive = data.isActive
  vm.activeText = vm.isActive ? "正常" : "已关闭"
  vm.createdTime = data.createdTime
  vm.updatedTime = data.updatedTime
  vm.postCount = data.postCount
}

const formatMemberData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(member => {
      return {
        id: member.id,
        name: member.name,
        phoneNumber: member.phoneNumber,
        location: member.location,
        company: member.company,
        industry: member.industry,
        isActive: member.isActive,
        activeText: member.isActive ? "正常" : "已退圈",
        joinedTime: member.joinedTime
      }
    })
  } else {
    return []
  }
}

const formatTagData = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(tag => {
      return {
        tagId: tag.tagId,
        tagName: tag.tagName
      }
    })
  } else {
    return []
  }
}

const formatTagOptions = (vm, data) => {
  if (Array.isArray(data)) {
    return data.map(tag => {
      return {
        tagId: tag.id,
        tagName: tag.name
      }
    })
  } else {
    return []
  }
}

export default {
  data() {
    return {
      // 基本资料详情窗口
      activeName: "first",
      id: '',
      coverImg: '',
      circleName: '',
      description: '',
      createdByName: '',
      isActive: '',
      activeText: '',
      createdTime: '',
      updatedTime: '',
      postCount: '',
      isEdit: false,
      originTags: [],
      tags: [],
      tagListOptions: [],
      members: [],
      memberTableData: [],
      memberPage: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      memberTableLoading: false,
      columnMemberOption: columnMemberOption,
      memberListQuery: {
        current: 1,
        size: 20
      }
    }
  },
  watch: {
    $route () {
      this.id = this.$route.params.id
      initDetail(this)
    }
  },
  mounted() {
    this.id = this.$route.params.id
    initDetail(this)
  },
  methods: {
    remoteSearchTag (params) {
      if (params && params.trim()) {
        getTagListByTag({
          tagName: params.trim()
        }).then(response => {
          this.tagListOptions = formatTagOptions(this, response.data.data)
        }).catch(error => {
          console.error(error)
          this.$message({
            message: "获取标签失败",
            type: "error"
          })
        })
      } else {
        this.tagListOptions = []
      }
    },
    getTagList() {
      fetchTagList(this.id).then(response => {
        this.originTags = formatTagData(this, response.data.data)
        this.tags = this.originTags
        this.tagListOptions = this.originTags
      }).catch(error => {
        console.error(error)
        this.$message({
          message: "获取专栏标签失败",
          type: "error"
        })
      })
    },
    getMemberList() {
      this.memberTableLoading = true
      fetchMemberList(this.memberListQuery, this.id).then(response => {
        this.memberTableData = formatMemberData(this, response.data.data.records)
        this.memberPage.total = response.data.data.total
        this.memberTableLoading = false
      }).catch(error => {
        console.error(error)
        this.memberTableLoading = false
        this.$message({
          message: "获取专栏成员失败",
          type: "error"
        })
      })
    },
    memberCurrentChange(val) {
      this.memberPage.current = val
      this.memberListQuery.current = val
      this.getMemberList()
    },
    memberSizeChange(val) {
      this.memberPage.size = val
      this.memberListQuery.size = val
      this.getMemberList()
    },
    changeMode(callback, tagIds) {
      updateCircleTags(this.id, tagIds).then(response => {
        if (response.data.data) {
          this.$message({
            message: '更新标签成功',
            type: 'success'
          })
          callback(true)
        } else {
          this.$message({
            message: response.data.msg,
            type: 'error'
          })
          callback(false)
        }
      }).catch(error => {
        callback(false)
      })
    },
    toPostList() {
      this.$router.push({
        path: "/post/essay",
        query: {
          columnId: this.id
        }
      })
    },
    handleEdit() {
      this.isEdit = true
    },
    handleCancelEdit() {
      this.tags = this.originTags
      this.tagListOptions = this.originTags
      this.isEdit = false
    },
    handleSaveEdit() {
      updateCircleTags(this.id, this.tags.map(x => x.tagId)).then(response => {
        if (response.data.data) {
          this.$message({
            message: '更新标签成功',
            type: 'success'
          })
          this.originTags = this.tags
          this.tagListOptions = this.originTags
          this.isEdit = false
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          message: response.data.msg,
          type: 'error'
        })
      })
    }
  }
}
</script>
<style lang="scss">
.column-detail {
  .one-line {
    font-size: 16px;
    margin: 10px 0;
    line-height: 40px;
  }
  .cover-image {
    width: 148px;
    height: 148px;
    float: left;
    vertical-align: top;
    margin-right: 8px;
  }
  .edit-button {
    margin-left: 10px;
  }
}
</style>

